import React from 'react';
import styles from './AdminDashboard.module.css';

const AdminDashboard = () => {
    return (
        <div className={styles.adminDashboardContainer}>
            <h2 className="page-main-title">Admin Dashboard</h2>
            <p>Welcome to the administrator control panel.</p>
            <p>Use the navigation or links below to manage users and reservations.</p>
        </div>
    );
};

export default AdminDashboard;
